import * as tslib_1 from "tslib";
import { getStore as getTabStore } from 'owa-tab-store/lib/store/tabStore';
import { getStore as getComposeStore } from '../store/composeStore';
import { TabType } from 'owa-tab-store';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
export default function findInlineComposeViewState(conversationId) {
    var e_1, _a;
    if (isTabViewEnabled()) {
        try {
            for (var _b = tslib_1.__values(getTabStore().tabs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tab = _c.value;
                if (tab.type == TabType.Compose &&
                    !tab.isShown &&
                    tab.data.isInlineCompose &&
                    tab.data.conversationId == conversationId &&
                    tab.data.asyncSendState == 0 /* None */) {
                    return tab.data;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    }
    else {
        var defaultViewState = getComposeStore().defaultViewState;
        return defaultViewState &&
            defaultViewState.isInlineCompose &&
            defaultViewState.conversationId == conversationId
            ? defaultViewState
            : null;
    }
}
//# sourceMappingURL=findInlineComposeViewState.js.map